import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=9165d01a&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=9165d01a&prod&lang=scss&scoped=true"
import style1 from "./Order.vue?vue&type=style&index=1&id=9165d01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9165d01a",
  null
  
)

export default component.exports